export const RECAPTCHA_ACTIONS = {
  ACCOUNT_UPGRADE: 'UPGRADE',
  PAID_SIGNUP: 'SIGNUP_PAID',
  FREE_SIGNUP: 'SIGNUP_FREE',
  NOCARD_SIGNUP: 'NOCARD_SIGNUP',
  ONLOAD: 'ONLOAD',
  EMAIL_EXISTS_CHECK: 'EMAIL_EXISTS_CHECK',
};

export const recaptchaSignupTypeMap = {
  free: RECAPTCHA_ACTIONS.FREE_SIGNUP,
  paid: RECAPTCHA_ACTIONS.PAID_SIGNUP,
  noCardSignup: RECAPTCHA_ACTIONS.NOCARD_SIGNUP,
};

export const RECAPTCHA_TYPE = {
  VISIBLE: '4b14a632',
  INVISIBLE: '3432323',
};
export const RECAPTCHA_INVISIBLE_SITE_KEY = window.getRecaptchaInvisibleSiteKey();
export const RECAPTCHA_CHECKBOX_SITE_KEY = window.getRecaptchaCheckBoxSiteKey();

export function getReCaptchaTokenAndExecuteCallback(
  action,
  processTokenCallback,
) {
  // eslint-disable-next-line no-unused-expressions
  window.grecaptcha?.enterprise?.ready(async () => {
    const token = await window.grecaptcha.enterprise?.execute(
      RECAPTCHA_INVISIBLE_SITE_KEY,
      { action },
    );
    processTokenCallback(token);
  });
}

export function initializeCheckboxRecaptcha(action) {
  window.grecaptcha.enterprise.ready(() => {
    window.grecaptcha.enterprise.render('recaptcha-checkbox', {
      sitekey: RECAPTCHA_CHECKBOX_SITE_KEY,
      action,
    });
  });
}

// invoked on click of pay/submit btn
export function getRecaptchaCheckboxToken() {
  if (window.grecaptcha) {
    return window.grecaptcha?.enterprise.getResponse();
  }
  return '';
}

export function isRecaptchaCheckBoxChecked(recaptchaToken) {
  return !!recaptchaToken;
}

export function resetRecaptchaCheckBox() {
  try {
    if (window.grecaptcha) {
      window.grecaptcha.enterprise.reset();
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
